import { useState } from 'react';
import type { GiayBaoCo } from '@/types/schemas/giay-bao-co.type';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useGiayBaoCoExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportGiayBaoCoExcel, exportGiayBaoCoFromApi } = await import('../utils/excel-export');
      if (entity?.slug) {
        await exportGiayBaoCoFromApi({
          entitySlug: entity.slug
        });
        return;
      }

      await exportGiayBaoCoExcel();
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
